<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div>
          <h1 class="page-header">Bekräfta PUB-avtal och underteckna (steg 3 av 3) </h1>
          <p class="intro">Klicka i “Jag bekräftar” och tryck på “Underteckna”. Då sparas både Överenskommelse och
            PUB-avtal och skickas till SPSM för godkännande. </p>
          <p class="intro">Om du väljer “Avbryt” sparas varken Överenskommelse eller PUB-avtal. </p>
        </div>
        <form class="reg-form" @submit.prevent="onSubmit">
          <div class="reg-form__wrapper">
            <PDFView v-if="state.pubAgreementPath" :path="state.pubAgreementPath" />
          </div>
          <div class="checkbox-container">
            <div class="form-check">
              <input id="confirm" v-model="form.confirm" class="form-check-input sr-only"
                     required type="checkbox" />
              <label class="form-check-label" for="confirm">Jag bekräftar</label>
            </div>
          </div>
          <CtaPanel>
            <div class="buttons-container push-buttons-right">
              <PreviousNavLink :go-to-link="`/organisation/${orgId}`"
                               previous-label="Avbryt"></PreviousNavLink>
              <button class="btn btn-light" type="submit">Underteckna &nbsp;&nbsp;<span
                class="fas fa-check"></span></button>
            </div>
          </CtaPanel>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "@vue/runtime-core";
import CtaPanel from "../components/CtaPanel.vue";
import PDFView from "../components/PDFView.vue";
import { useOrganisationStore } from "@/stores/organisation";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

interface confirm {
  confirm: boolean;
}

export default defineComponent({

  name: "OrgAgreementConfirmPub",
  components: {
    CtaPanel,
    PDFView,
    PreviousNavLink
  },
  setup() {
    const form = ref<confirm>({
      confirm: false
    });
    const baseUrl = import.meta.env.VITE_APP_URL;
    const route = useRoute();
    const router = useRouter();
    const organisationStore = useOrganisationStore();
    const { orgId } = route.params;
    const { pubAgreement } = storeToRefs(organisationStore);

    if (!pubAgreement?.value?.id) {
      const agreement = JSON.parse(sessionStorage.getItem("agreement") as string);
      organisationStore.setPubAgreement(agreement);
    }

    const state = reactive({
      pubAgreementPath: `${baseUrl}/agreement/${pubAgreement?.value?.id}/GetPubAgreementPdf/`
    });

    const onSubmit = async () => {
      if (form.value.confirm) {
        if (orgId && pubAgreement && pubAgreement.value && pubAgreement.value.agreementId && pubAgreement.value.id)
          await organisationStore.SignAgreement(orgId as string, pubAgreement.value.agreementId, pubAgreement.value.id).then((result) => {
            if (result) {
              router.push(`/organisation/${orgId}/avtal/bekrafta/summering`);
            }
          });
      }
    };
    return {
      state,
      orgId,
      form,
      onSubmit
    };
  }
});
</script>

<style lang="scss" scoped>
.reg-form__wrapper {
  [class^="col-"] {
    background: var(--spsm-gray-5);
    padding: 1rem;
    border-radius: 0.2rem;
  }
}

.checkbox-container {
  display: flex;
  margin-bottom: 16px;
  justify-content: end;
}
</style>